const state = {
  regions: [],
  departements: []
};

const mutations = {
  SET_REGIONS(state, regions) {
    state.regions = regions;
  },
  SET_DEPARTEMENTS(state, departements) {
    state.departements = departements;
  }
};

const actions = {
  saveRegions({ commit }, regions) {
    commit("SET_REGIONS", regions);
  },
  saveDepartements({ commit }, departements) {
    commit("SET_DEPARTEMENTS", departements);
  }
};

const getters = {
  regions(state) {
    return state.regions;
  },
  departements(state) {
    return state.departements;
  },
  isRegions(state) {
    return state.regions.length > 0;
  },
  nomRegionByInseeRegion: state => inseeRegion => {
    const region = state.regions.find(
      region => region.inseeRegion == inseeRegion
    );
    return region.nomRegionMaj;
  },
  nomRegionListByInseeRegionList: state => inseeRegion => {
    const regions = [];
    // Filtrage des régions selon une liste de code insee
    inseeRegion.forEach(inseeRegion => {
      const region = state.regions.find(region => {
        return region.inseeRegion == inseeRegion;
      });
      regions.push(region);
    });
    // Renvoi la liste des noms
    return regions.map(region => region.nomRegionMaj);
  },
  nomDepartementListByInseeDepartementList: state => inseeDepartement => {
    const departements = [];

    inseeDepartement.forEach(inseeDepartement => {
      const departement = state.departements.find(departement => {
        return departement.inseeDepartement == inseeDepartement;
      });
      departements.push(departement);
    });

    return departements.map(departement => departement.nomDepartementMaj);
  },
  departementsByInseeRegion: state => inseeRegion => {
    return state.departements.filter(
      departement => departement.inseeRegion == inseeRegion
    );
  },
  isCollectivites(state) {
    return state.regions.length > 0 && state.departements.length > 0;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
